import { CampaignConfigSchema } from '../types';

export const isFieldVisible = (fieldConfig: { visible?: boolean }): boolean =>
  fieldConfig?.visible === true;

export const isFieldRequired = (fieldConfig: { required?: boolean }): boolean =>
  fieldConfig?.required === true;

const isFieldActive = (fieldConfig: { active?: boolean }): boolean =>
  fieldConfig?.active === true;

const getFieldValue = <T = string>(fieldConfig: { value?: T | null }): T | null =>
  fieldConfig?.value ?? null;

export const getFieldValues = <T = string>(fieldConfig?: { values?: T[] }): T[] =>
  fieldConfig?.values ?? [];

const DEFAULT_OPT_OUT_TEXT = 'Reply STOP to opt-out';

/** Keyed off `active` alone — a visible-but-inactive opt-out starts switched off. */
export const isOptOutEnabledByDefault = (config: CampaignConfigSchema): boolean =>
  isFieldActive(config.opt_out_message);

/** Never blank: falls back to DEFAULT_OPT_OUT_TEXT so the field always has copy. */
export const getDefaultOptOutText = (config: CampaignConfigSchema): string =>
  getFieldValue<string>(config.opt_out_message) || DEFAULT_OPT_OUT_TEXT;

export const isAppointmentTypeVisible = (config: CampaignConfigSchema): boolean =>
  isFieldVisible(config.appointment_type);

export const shouldAttachCalendarInvite = (config: CampaignConfigSchema): boolean =>
  isFieldActive(config.attach_calendar_invite) && isFieldVisible(config.attach_calendar_invite);

export const getAllowedMessageTypes = (config: CampaignConfigSchema): string[] =>
  config.message?.types || [];

/**
 * Contact capture adds signups to the campaign's groups directly, so a join
 * campaign created from it has no keywords and needs groups. The saved external
 * type is fixed by the dialog, not derived here: an application's config would
 * make the policy save it as `custom`.
 */
export const toContactToGroupConfig = (config: CampaignConfigSchema): CampaignConfigSchema => ({
  ...config,
  keywords: { ...config.keywords, values: [], visible: false, required: false },
  recipients: { ...config.recipients, visible: true, required: true },
});
